export default __webpack_public_path__ + "media/images/logo-dark-8f0609eab8def3eda843bb71ee453174.svg";